import React, { useState, useEffect, useRef, useMemo } from "react"
import { useQuery, useQueryClient } from "react-query"
import { fetchDeals } from "../../../services/main.service"
import Paginator from "../../composites/paginator"
import WithAuth from "../../hoc/with-auth"
import { LayoutWithSidebar } from "../../layouts/layout-with-sidebar.tsx"
import {
  Badge,
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Link as Clink,
  useMenuItem,
} from "@chakra-ui/react"
import _ from "lodash"
import { getAllAccounts } from "../../../services/crm.service"
import { AgGridReact } from "ag-grid-react"
import { Link, useNavigate } from "react-router-dom"
import { colors } from "../../../config/colors.tsx"

// const captions = [
//   "Time",
//   "Login",
//   "Buy/Sell",
//   "Entry",
//   "Deal",
//   "Symbol",
//   "Volume",
//   "Profit",
//   "Comment",
// ]

const captions = [
  "Deal",
  "Order",
  "Position",
  "Login",
  "Name",
  "Time",
  "Type",
  "Entry",
  "Symbol",
  "Volume",
  "Price",
  "S / L",
  "T / P",
  "Reason",
  "Commission",
  "Fee",
  "Profit",
  "Dealer",
  "Comment",
]

const getColorHex = (key: any) => {
  const c = _.find(colors, (c) => (c.key === key ? true : false))

  console.log(c)

  if (c) return c

  return key
}

const DealsPage = () => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(["accounts"], () => getAllAccounts(), {
    refetchInterval: 4000,
  })

  const navigate = useNavigate()
  const gridRef = useRef<any>() // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState() // Set rowData to Array of Objects, one Object per Row

  // [{"login":1000,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},{"login":1001,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},
  // Each Column Definition results in one Column.

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      // make every column editable
      editable: false,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
      // enable floating filters by default
      floatingFilter: true,
      // make columns resizable
      resizable: true,
      // disable cell data types
      cellDataType: false,
      sortable: true,
    }),
    []
  )

  const pinnedBottomRows = useMemo(() => {
    let bottomRow: any = []

    if (data?.data?.data.length) {
      // data?.data?.data[0]
      // login name balance equity credit margin_used margin_level margin_free
      return [
        {
          ...data?.data?.data[0],
          login: "",
          name: "",
          balance: _.sumBy(data?.data?.data, "balance").toFixed(2),
          equity: _.sumBy(data?.data?.data, "equity").toFixed(2),
          credit: _.sumBy(data?.data?.data, "credit").toFixed(2),
          margin_used: _.sumBy(data?.data?.data, "margin_used").toFixed(2),
          margin_level: _.sumBy(data?.data?.data, "margin_level").toFixed(2),
          margin_free: _.sumBy(data?.data?.data, "margin_free").toFixed(2),
          group: "",
        },
      ]
    }

    return bottomRow
  }, [data?.data?.data])

  const rows = useMemo(() => {
    if (data?.data?.data?.length) {
      return _.map(data?.data?.data, (_acc) => {
        return {
          ..._acc,
          margin_level: _acc?.margin_level?.toFixed(2),
          balance: _acc?.balance?.toFixed(2),
          equity: _acc?.equity?.toFixed(2),
          credit: _acc?.credit?.toFixed(2),
          margin_free: _acc?.margin_free?.toFixed(2),
          margin_used: _acc?.margin_used?.toFixed(2),
        }
      })
    }

    return []
  }, [data?.data?.data])

  const onEditUser = (login: number) => {
    const u = _.find(rows, (_r) => {
      return _r?.login === login ? true : false
    })

    if (u) {
      navigate(`/accounts/${login}/edit?name=$`)
    }
  }

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Login",
      field: "login",
      cellRenderer: (params: any) => {
        return (
          <>
            <Link to={`/accounts/${params?.value}`}>
              <span style={{ textDecoration: "underline" }}>
                {params?.value}
              </span>
            </Link>
          </>
        )
      },
    },
    { headerName: "Name", field: "name" },
    { headerName: "Group", field: "group" },
    { headerName: "Balance", field: "balance" },
    { headerName: "Equity", field: "equity" },
    { headerName: "Credit", field: "credit" },
    { headerName: "Margin Used", field: "margin_used" },
    { headerName: "Margin Level", field: "margin_level" },
    { headerName: "Margin Free", field: "margin_free" },
    {
      headerName: "Color",
      field: "color",
      cellRenderer: (params: any) => {
        if (!params?.value) return ""
        return (
          <>
            <div
              style={{
                width: "100%",
                height: "32px",
                background: getColorHex(params?.value)?.hex ?? "",
              }}
            >
              {!getColorHex(params?.value)?.title ||
              getColorHex(params?.value)?.title === "None"
                ? "None"
                : ""}
            </div>
          </>
        )
      },
    },

    {
      headerName: "Deposit & Withdrawal",
      field: "login",
      cellRenderer: (params: any) => {
        if (!params?.value) return ""

        return (
          <>
            <Link to={`/deposits-and-withdrawals?login=${params?.value}`}>
              <span style={{ textDecoration: "underline" }}>View</span>
            </Link>
          </>
        )
      },
    },

    {
      headerName: "Edit User",
      field: "login",
      cellRenderer: (params: any) => {
        if (!params?.value) return ""
        return (
          <>
            <Link to={`/accounts/${params?.value}/edit`}>
              <span style={{ textDecoration: "underline" }}>Edit User</span>
            </Link>
          </>
        )
      },
    },
    {
      headerName: "Edit Permission",
      field: "login",
      cellRenderer: (params: any) => {
        if (!params?.value) return ""
        return (
          <>
            <Link to={`/accounts/${params?.value}/permission`}>
              <span style={{ textDecoration: "underline" }}>
                Edit Permission
              </span>
            </Link>
          </>
        )
      },
    },
  ])

  return (
    <>
      <div className="ag-grid-container">
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "calc(100vh - 100px)" }}
        >
          <AgGridReact
            suppressScrollOnNewData={true}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={rows ?? []} // Row Data for Rows
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            overlayNoRowsTemplate={
              isLoading ? "Loading Accounts..." : "No Accounts found"
            }
            //  suppressScrollOnNewData={true}
            pinnedBottomRowData={pinnedBottomRows}
            onFilterChanged={(...val) => {
              console.log("FIL")
              console.log(val)
            }}
            onFilterModified={(...val) => {
              console.log("FIL MOD")
              console.log(val)
            }}
          />
        </div>
      </div>
    </>
  )
}

export default DealsPage

const DealsGrid = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Box overflowX="auto">
        <Table variant="striped" color="text.regular" border={1}>
          <Thead>
            <Tr my=".8rem" ps="0px">
              {captions.map((caption, idx) => {
                return (
                  <Th
                    color="gray.400"
                    key={idx}
                    ps={idx === 0 ? "0px" : "0px"}
                    textAlign={caption === "PL" ? "right" : "unset"}
                  >
                    {caption}
                  </Th>
                )
              })}
            </Tr>
          </Thead>
          <Tbody>{children}</Tbody>
        </Table>
      </Box>
    </>
  )
}

const DealsTableRow = ({ deal }: { deal: any }) => {
  const TBlock = (_val: any) => {
    return (
      <Td>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          {/* <Icon as={logo} h={"24px"} w={"24px"} pe="5px" /> */}
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {_val}
          </Text>
        </Flex>
      </Td>
    )
  }

  const renderPofitLoss = (_amount: any) => {
    return (
      <Text
        color={_amount < 0 ? "red" : "green"}
        fontSize="md"
        fontWeight="bold"
        minWidth="100%"
        textAlign="left"
      >
        {_amount}
      </Text>
    )
  }

  return (
    <>
      <Tr>
        {_.map(deal, (_d, index) => {
          if (deal?.length === index + 1) return <></>

          return (
            <Td pl={1} pr={2}>
              <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
                <Text fontSize="md" fontWeight="bold" minWidth="100%">
                  {_d}
                </Text>
              </Flex>
            </Td>
          )
        })}
      </Tr>
    </>
  )

  return (
    <Tr>
      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Time}
          </Text>
        </Flex>
      </Td>
      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Login}
          </Text>
        </Flex>
      </Td>
      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Action === 0 ? (
              <>
                <Badge colorScheme="green">BUY</Badge>
              </>
            ) : (
              <Badge colorScheme="red">SELL</Badge>
            )}
          </Text>
        </Flex>
      </Td>

      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Entry === 0 ? "IN" : "OUT"}
          </Text>
        </Flex>
      </Td>
      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Deal}
          </Text>
        </Flex>
      </Td>

      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Symbol}
          </Text>
        </Flex>
      </Td>

      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Text fontSize="md" fontWeight="bold" minWidth="100%">
            {deal?.Volume}
          </Text>
        </Flex>
      </Td>

      <Td pl={1} pr={2}>
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          {renderPofitLoss(deal?.Profit)}
        </Flex>
      </Td>

      <Td pl={1} pr={2}>
        <Flex py=".8rem" minWidth="100%" flexWrap="nowrap">
          {deal?.Comment ?? "-"}
        </Flex>
      </Td>
    </Tr>
  )
}
